/** Presentation only; the database retains exact nanodollar accounting. */
export const usdFormatter=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',minimumFractionDigits:2,maximumFractionDigits:2});
export const formatUsd=(value:string|number):string=>usdFormatter.format(Number(value));
